module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize.debounce",
      value: (_vm.onResize),
      expression: "onResize",
      modifiers: {
        "debounce": true
      }
    }],
    staticClass: "viewport perspective",
    on: {
      "mousedown": _vm.mousedown,
      "mousemove": _vm.mousemove,
      "mouseup": _vm.mouseup
    }
  }, [_c('canvas', {
    staticClass: "layer3D"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-267f7bb4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PerspectiveViewport.vue
// module id = 113
// module chunks = 1